import { render, staticRenderFns } from "./WhsD_Details.vue?vue&type=template&id=57137f99"
import script from "./WhsD_Details.vue?vue&type=script&lang=js"
export * from "./WhsD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports